import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { AuthService } from 'src/app/service/auth.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';

@Component({
  selector: 'app-detalhe-resultado-aprovado',
  templateUrl: './detalhe-resultado-aprovado.component.html',
  styleUrls: ['./detalhe-resultado-aprovado.component.scss']
})
export class DetalheResultadoAprovadoComponent implements OnInit {

  public tituloTriagem: string;
  public idTriagem: number;
  public htmlRespostas: string;
  public arrayResultado: any[];
  public arrayDivisaoGrupos: any[];
  public arrayDivisaoGruposOriginal: any[];
  public query: string;
  public objResultado: any;
  public itensSelecionados: any[] = [];
  //public filtroRadio: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ajax: AjaxService,
    public util: UtilService,
    private auth: AuthService
  ) { 
    this.arrayDivisaoGrupos = [];
    //this.filtroRadio = 
  }

  ngOnInit() {
    this.idTriagem = this.activatedRoute.snapshot.params['id'];
    this.tituloTriagem = this.activatedRoute.snapshot.params['titulo'];
    this.buscarDivisaoGrupos();
  }

  buscarAprovados(){
    this.util.showLoading();
    let url = API + "RespostaFormulario/RespostaFormulario/buscarResultadosAprovados/" + this.idTriagem;
    return this.ajax.get(url)
      .subscribe(response => {
        this.objResultado = response.data;
        this.arrayResultado = response.data.listResultadoPorPessoa;
        // Marca todos os itens como selecionados por padrão
        if (this.arrayResultado && this.arrayResultado.length > 0) {
          this.itensSelecionados = [...this.arrayResultado];
        }
        this.util.closeLoading();
        
      }, err => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Não existe Pessoas Aprovadas no momento");
      });
  }

  filter(string){
    if(string != null)
      this.arrayDivisaoGrupos = this.arrayDivisaoGruposOriginal.filter(c => c.grupo == string);
    else
      this.arrayDivisaoGrupos = this.arrayDivisaoGruposOriginal;
    
    // Garante que os itens filtrados que já estavam selecionados permaneçam selecionados
    // e adiciona os novos itens visíveis que não estavam selecionados
    if (this.arrayDivisaoGrupos && this.arrayDivisaoGrupos.length > 0) {
      this.arrayDivisaoGrupos.forEach(item => {
        if (!this.isItemSelecionado(item)) {
          this.itensSelecionados.push(item);
        }
      });
    }
  }

  buscarDivisaoGrupos(){
    this.util.showLoading();
    let url = API + "DivisaoGrupo/DivisaoGrupo/BuscarGrupos/" + this.idTriagem;
    return this.ajax.get(url)
      .subscribe(response => {
        debugger
        this.arrayDivisaoGruposOriginal = response.data;
        this.arrayDivisaoGrupos = response.data;
        // Marca todos os itens como selecionados por padrão
        if (response.data && response.data.length > 0) {
          this.itensSelecionados = [...response.data];
        }
        this.util.closeLoading();  

        if(response.data.length == 0)
          this.buscarAprovados();

      }, err => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar Resultados");
      });
  }

  montarObj(){
    let obj = [];
    this.arrayResultado.forEach(item => { 
      // Só adiciona se o item estiver selecionado
      if (this.isItemSelecionado(item)) {
        obj.push({ 
          "ID_TRIAGEM": item.iD_TRIAGEM, 
          "ID_RESPONSAVEL_TEA": item.iD_RESPONSAVEL,
          "ID_CRIANCA": item.iD_CRIANCA
        });
      }
    });
    return obj;
  }

  gerarGrupos(){
    let dados = this.montarObj();
    debugger
    if(dados.length > 0){
      console.log(dados);
      this.util.showLoading();
    let url = API + "DivisaoGrupo/DivisaoGrupo/DividirGrupos";
    return this.ajax.post(url, dados)
      .subscribe(response => {
        console.log("responstar ao gerar grupo",response);
        this.util.closeLoading();
        this.util.toasterShowSuccess("Atenção", "Grupos Gerados com Sucesso!");
        this.buscarDivisaoGrupos();
      }, err => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Gerar Grupos");
      });
    }
    
  }

  toggleSelecao(item: any, isChecked: boolean) {
    const itemId = item.id || item.iD_RESPONSAVEL_TEA || item.iD_CRIANCA || item.iD_RESPOSTA_FORMULARIO;
    if (isChecked) {
      if (!this.itensSelecionados.find(i => {
        const iId = i.id || i.iD_RESPONSAVEL_TEA || i.iD_CRIANCA || i.iD_RESPOSTA_FORMULARIO;
        return iId === itemId;
      })) {
        this.itensSelecionados.push(item);
      }
    } else {
      this.itensSelecionados = this.itensSelecionados.filter(i => {
        const iId = i.id || i.iD_RESPONSAVEL_TEA || i.iD_CRIANCA || i.iD_RESPOSTA_FORMULARIO;
        return iId !== itemId;
      });
    }
  }

  isItemSelecionado(item: any): boolean {
    const itemId = item.id || item.iD_RESPONSAVEL_TEA || item.iD_CRIANCA || item.iD_RESPOSTA_FORMULARIO;
    return this.itensSelecionados.some(i => {
      const iId = i.id || i.iD_RESPONSAVEL_TEA || i.iD_CRIANCA || i.iD_RESPOSTA_FORMULARIO;
      return iId === itemId;
    });
  }

  // Aplica o mesmo filtro do pipe fullTextSearch
  aplicarFiltroBusca(array: any[]): any[] {
    if (!this.query || !array) {
      return array || [];
    }
    const queryLower = this.query.toLocaleLowerCase();
    return array.filter(obj =>
      Object.keys(obj)
        .map(key => obj[key])
        .toString()
        .toLocaleLowerCase()
        .indexOf(queryLower) !== -1
    );
  }

  marcarTodos() {
    if (this.arrayDivisaoGrupos.length > 0) {
      // Se estiver na view de grupos - aplica filtro de busca
      const itensFiltrados = this.aplicarFiltroBusca(this.arrayDivisaoGrupos);
      itensFiltrados.forEach(item => {
        if (!this.isItemSelecionado(item)) {
          this.itensSelecionados.push(item);
        }
      });
    } else if (this.arrayResultado && this.arrayResultado.length > 0) {
      // Se estiver na view de resultados - aplica filtro de busca
      const itensFiltrados = this.aplicarFiltroBusca(this.arrayResultado);
      itensFiltrados.forEach(item => {
        if (!this.isItemSelecionado(item)) {
          this.itensSelecionados.push(item);
        }
      });
    }
  }

  desmarcarTodos() {
    if (this.arrayDivisaoGrupos.length > 0) {
      // Se estiver na view de grupos - aplica filtro de busca
      const itensFiltrados = this.aplicarFiltroBusca(this.arrayDivisaoGrupos);
      const idsFiltrados = itensFiltrados.map(item => {
        return item.id || item.iD_DIVISAO_GRUPO || item.iD_RESPONSAVEL_TEA || item.iD_CRIANCA;
      });
      this.itensSelecionados = this.itensSelecionados.filter(item => {
        const itemId = item.id || item.iD_DIVISAO_GRUPO || item.iD_RESPONSAVEL_TEA || item.iD_CRIANCA;
        return !idsFiltrados.includes(itemId);
      });
    } else if (this.arrayResultado && this.arrayResultado.length > 0) {
      // Se estiver na view de resultados - aplica filtro de busca
      const itensFiltrados = this.aplicarFiltroBusca(this.arrayResultado);
      const idsFiltrados = itensFiltrados.map(item => {
        return item.id || item.iD_RESPONSAVEL || item.iD_CRIANCA || item.iD_RESPOSTA_FORMULARIO;
      });
      this.itensSelecionados = this.itensSelecionados.filter(item => {
        const itemId = item.id || item.iD_RESPONSAVEL || item.iD_CRIANCA || item.iD_RESPOSTA_FORMULARIO;
        return !idsFiltrados.includes(itemId);
      });
    }
  }

  toggleMarcarTodos(isChecked: boolean) {
    if (isChecked) {
      this.marcarTodos();
    } else {
      this.desmarcarTodos();
    }
  }

  todosEstaoSelecionados(): boolean {
    if (this.arrayDivisaoGrupos.length > 0) {
      const itensFiltrados = this.aplicarFiltroBusca(this.arrayDivisaoGrupos);
      if (itensFiltrados.length === 0) return false;
      return itensFiltrados.every(item => this.isItemSelecionado(item));
    } else if (this.arrayResultado && this.arrayResultado.length > 0) {
      const itensFiltrados = this.aplicarFiltroBusca(this.arrayResultado);
      if (itensFiltrados.length === 0) return false;
      return itensFiltrados.every(item => this.isItemSelecionado(item));
    }
    return false;
  }

  calcularIdade(item: any): string {
    // Retorna a idade diretamente do atributo idade
    if (item.idade != null && item.idade !== undefined) {
      return item.idade.toString();
    }
    return '-';
  }

  calcularIdadeGrupo(item: any): string {
    // Retorna a idade diretamente do atributo idade ou criancA_IDADE
    if (item.idade != null && item.idade !== undefined) {
      return item.idade.toString();
    }
    if (item.criancA_IDADE != null && item.criancA_IDADE !== undefined) {
      return item.criancA_IDADE.toString();
    }
    return '-';
  }

  obterEscalas(item: any): any[] {
    // Retorna a lista de escalas do item
    if (item.escalas && Array.isArray(item.escalas)) {
      return item.escalas;
    }
    return [];
  }

  formatarEscala(escala: any): string {
    // Formata a escala no formato: nome - corte/ponto
    if (escala && escala.nome) {
      const corte = escala.corte != null ? escala.corte : '-';
      const ponto = escala.ponto != null ? escala.ponto : '-';
      return `${escala.nome} - ${corte}/${ponto}`;
    }
    return '-';
  }

}
